"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useFetch_1 = __importDefault(require("../../hooks/useFetch"));
const auth_1 = require("../../util/auth");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const auth0_react_1 = require("@auth0/auth0-react");
const apiUtils_1 = require("../../util/apiUtils");
const common_styled_components_1 = require("../common-styled-components");
const Tools_1 = require("../Tools");
const NavigationContext_1 = require("../../contexts/NavigationContext");
const Main = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme_1.theme.spacing(4)};
  background-color: white;
  border-bottom-right-radius: ${common_styled_components_1.DEFAULT_RADIUS};

  @media (max-width: ${theme_1.breakpoints.tablet}px) {
    border-bottom-left-radius: ${common_styled_components_1.DEFAULT_RADIUS};
  }

  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    border-radius: 0;
  }
`;
const ToolGrid = styled_components_1.default.div `
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: ${theme_1.theme.spacing(4)};
  padding: ${theme_1.theme.spacing(4)};
`;
const ToolCard = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${theme_1.theme.spacing(0)};
`;
const ToolImage = styled_components_1.default.img `
  width: 100%;
  aspect-ratio: 16 / 9;
  background-color: white;
  object-fit: contain;
  object-position: center;
  display: block;
`;
const StyledLink = (0, styled_components_1.default)(NavigationContext_1.LinkWithHistory) `
  color: ${theme_1.theme.colors.blackText};
  text-decoration-style: none;
  text-decoration-line: none;
`;
const ToolHeader = styled_components_1.default.h2 `
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(1)};
  margin: 0;
  text-decoration: none;
  color: ${theme_1.theme.colors.blackText};
  text-decoration-style: none;
  text-decoration-line: none;
  text-align: center;
`;
exports.default = () => {
    const { isAuthenticated, loginWithRedirect } = (0, auth0_react_1.useAuth0)();
    const { user } = (0, auth_1.useAuthentication)();
    const [languageData] = (0, useFetch_1.default)("calculator/language/en", undefined);
    const texts = languageData.status === apiUtils_1.LoaderStatus.Success
        ? languageData.data
        : undefined;
    const prod = process.env.NODE_ENV === "production";
    if (!texts) {
        return (0, jsx_runtime_1.jsx)("div", {});
    }
    const filteredTools = (0, Tools_1.getTools)(user, isAuthenticated);
    if (!filteredTools.length) {
        return ((0, jsx_runtime_1.jsx)(common_styled_components_1.UISection, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.P, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.A, { onClick: (e) => {
                        e.preventDefault();
                        loginWithRedirect();
                    }, style: { cursor: "pointer" }, children: "Log in" }) }) }));
    }
    return ((0, jsx_runtime_1.jsx)(Main, { children: (0, jsx_runtime_1.jsx)(ToolGrid, { children: filteredTools.map((tool) => ((0, jsx_runtime_1.jsx)(StyledLink, { to: tool.path, children: (0, jsx_runtime_1.jsxs)(ToolCard, { children: [(0, jsx_runtime_1.jsx)(ToolImage, { src: tool.image }), (0, jsx_runtime_1.jsxs)(ToolHeader, { children: [!isAuthenticated ? "Public " : "", tool.name] })] }) }, tool.path))) }) }));
};
